import { bindArrayStore, bindCustomStore } from './bindCustomStore';
import { calculateHeight } from './calculateHeight';
import * as ClientMethods from './clientMethods';
import { customLoad, customSave } from './stateStoring';
import { onCellPrepared } from './onCellPrepared';
import { onChangesChange } from './onChangesChange';
import { onContentReady } from './onContentReady';
import { onContextMenuOpen } from './onContextMenuOpen';
import { onEditCanceling } from './onEditCanceling';
import { onEditingStart } from './onEditingStart';
import { onEditorPreparing } from './onEditorPreparing';
import { onExporting } from './onExporting';
import { onInitNewRow } from './onInitNewRow';
import { onRowDblClick } from './onRowDblClick';
import { onRowInserted } from './onRowInserted';
import { onRowInserting } from './onRowInserting';
import { onRowRemoved } from './onRowRemoved';
import { onRowRemoving } from './onRowRemoving';
import { onRowUpdated } from './onRowUpdated';
import { onRowUpdating } from './onRowUpdating';
import { onSelectionChanged } from './onSelectionChanged';
import { onSelectionChanging } from './onSelectionChanging';
import { onSummaryChanged } from './onSummaryChanged';
import { setSelectionResult } from './setSelectionResult';
import { emitRelationEvents } from './emitRelationEvents';

export const Methods = {
	onChangesChange,
	calculateHeight,
	onInitNewRow,
	onContextMenuOpen,
	onExporting,
	onEditorPreparing,
	onRowDblClick,
	onRowRemoving,
	onRowRemoved,
	onRowInserting,
	onRowInserted,
	onRowUpdating,
	onRowUpdated,
	onSelectionChanged,
	onSelectionChanging,
	onEditingStart,
	onCellPrepared,
	onEditCanceling,
	bindCustomStore,
	bindArrayStore,
	onSummaryChanged,
	onContentReady,
	customSave,
	customLoad,
	setSelectionResult,
	emitRelationEvents,
	...ClientMethods
};
